import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './email-template.action';

@Injectable({ providedIn: 'root' })
export class EmailTemplateTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                is_active: null,
                title: '', 
                template_for: null
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'title';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    statuses = [
        {"id": "1", "name": "COMMON.active"},
        {"id": "0", "name": "COMMON.inactive"}
    ];
    
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'title', name: 'EMAIL_TEMPLATE.field-title', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'is_active', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name", widthSet: 180},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: "", widthSet: 180},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '',
            is_active: null,
            title: '',
            template_for: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}